import React, { memo, useCallback } from "react";

import I18nText from "../../../components/I18nText/I18nText";
import { Image } from "../../../components/elements";
import { ICategoryList } from "../types";
import "./CategoryList.scss";

interface ICategoryListProps {
	categories: ICategoryList[];
	activeCategoryId: string | null;
	onCategoryClick: (categoryId: string) => void;
	listRef?: React.RefObject<HTMLDivElement>;
}

const CategoryList: React.FC<ICategoryListProps> = ({
	categories,
	activeCategoryId,
	onCategoryClick,
	listRef,
}) => {
	const handleCategoryClick = useCallback(
		(categoryId: string) => () => onCategoryClick(categoryId),
		[onCategoryClick]
	);

	return (
		<div className="CategoryList" ref={listRef}>
			{categories.map((category) => (
				<div
					key={category.id}
					className={`CategoryItem ${category.id === activeCategoryId ? "CategoryItem-active" : ""}`}
					onClick={handleCategoryClick(category.id)}
				>
					<div className="CategoryIcon">
						<Image src={category.product_image} alt={category.name} />
					</div>
					<div className="CategoryLabel">
						<I18nText enText={category.name} cnText={category.name_cn} />
					</div>
				</div>
			))}
		</div>
	);
};

export default memo(CategoryList);
